import {ActivatedRouteSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {CompetitorResultsService} from "@services";
import {CategoryItem, CompetitorFilter, CompetitorResults, PagedFilter, Pages} from "@model";
import {inject} from "@angular/core";
import {ResolveFn, RouterStateSnapshot} from "@angular/router";

export const CompetitorResultListResolver: ResolveFn<Observable<CompetitorResults[]> | any> =
  (route: ActivatedRouteSnapshot,
   _: RouterStateSnapshot,
   competitorResultsService: CompetitorResultsService = inject(CompetitorResultsService)): Observable<CompetitorResults[]> | any => {
    let raceId: number | undefined = +route.queryParams['raceId'] ? +route.queryParams['raceId'] : undefined;
    let eventId: number | undefined = +route.queryParams['eventId'] ? +route.queryParams['eventId'] : undefined;
    let competitorFilter: CompetitorFilter = new CompetitorFilter();
    competitorFilter.raceId = raceId;
    competitorFilter.eventId = eventId;
    return competitorResultsService.getCompetitorResults(new PagedFilter(new Pages(), competitorFilter));
  }

export const CategoriesResolver: ResolveFn<Observable<CategoryItem[]> |
  Promise<CategoryItem[]> | CategoryItem[]> =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   competitorResultsService: CompetitorResultsService = inject(CompetitorResultsService)): Observable<CategoryItem[]> |
    Promise<CategoryItem[]> | CategoryItem[] => {
    if (route.queryParams['raceId']) {
      return competitorResultsService.findCategoryItemsByRaceId(+route.queryParams['raceId']);
    } else if (route.queryParams['eventId']) {
      return competitorResultsService.findCategoryItemsByEventId(+route.queryParams['eventId']);
    } else {
      return [];
    }
  }
